import React, { useEffect, useState, useContext } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import BusinessCard from '../../components/businessCard/BusinessCard';
import axiosConn from '../../axiosConn';
import './businessDirectory.css';

const BusinessDirectory = () => {
  const { player } = useContext(AuthContext);
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterClue, setFilterClue] = useState(false);

  useEffect(() => {
    const fetchBusinesses = async () => {
      try {
        const res = await axiosConn.get('businesses', {
          headers: { Authorization: `Bearer ${player?.token}` },
        });
        setBusinesses(res.data.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching businesses', err);
        setLoading(false);
      }
    };
    fetchBusinesses();
  }, [player?.token]);

  const filteredBusinesses = filterClue
    ? businesses.filter((b) => b.hasClue)
    : businesses;

  // Sort by createdAt descending (newest first)
  const sortedBusinesses = [...filteredBusinesses].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  );

  if (loading)
    return <Spinner animation="border" className="d-block mx-auto mt-5" />;

  return (
    <div className="container mt-3 mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 style={{ fontWeight: 700, letterSpacing: 0.5 }}>
          <span role="img" aria-label="directory">
            📍
          </span>{' '}
          Business Directory
        </h2>
        <Button
          variant={filterClue ? 'primary' : 'outline-primary'}
          onClick={() => setFilterClue(!filterClue)}
        >
          {filterClue ? 'Show All' : 'Show Only with Clues'}
        </Button>
      </div>
      <div className="row g-2 g-md-3">
        {sortedBusinesses.map((biz) => (
          <div className="col-12 col-sm-6 col-md-4" key={biz._id}>
            <BusinessCard biz={biz} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessDirectory;
